<template>
	<CreationWizardStepWrapper>
		<template #header>
			<ChoosePlacementForButtonDropdownHeader v-bind="$props" v-on="$listeners" />
		</template>
		<div class="display-flex height-100 flex-wrap">
			<div class="flex-col-12">
				<div class="top-section">
					<h2 class="med">Choose the <span class="bold">context</span> for the button dropdown</h2>
					<h3 class="reg">The context will determine which features are available to use in this button dropdown.</h3>
				</div>
				<PlacementSelector
					class="list-selector mt-3"
					:selectedPlacementId="selectedPlacementId"
					:selectedPlacement="selectedPlacement"
					:placements="enrichedPlacements"
					@selectPlacement="selectPlacement"
					:serviceName="service.service_name"
				>
					<template #item-content="{ item }">
						<PlacementRowContent entityName="button dropdown" :itemName="getItemName(item)" />
					</template>
				</PlacementSelector>
			</div>
		</div>
	</CreationWizardStepWrapper>
</template>

<script>
import props from './ChoosePlacementForButtonDropdown.props';
import ChoosePlacementForButtonDropdownHeader from './ChoosePlacementForButtonDropdownHeader.vue';
import PlacementSelector from '../common/PlacementSelector.vue';
import PlacementRowContent from '../common/PlacementRowContent.vue';
import WizardStepMixin from '../WizardStepMixin';
import PlacementService from '@/utils/placement-service';
export default {
	name: 'ChoosePlacementForButtonDropdown',
	mixins: [WizardStepMixin],
	components: { ChoosePlacementForButtonDropdownHeader, PlacementSelector, PlacementRowContent },
	props,
	computed: {
		selectedPlacement: {
			get() {
				return this.findPlacement(this.selectedPlacementId);
			},
			set(placementId) {
				this.updateState({ key: 'selectedPlacementId', value: placementId });
			},
		},
		enrichedPlacements() {
			return this.placements.map((p) => ({ ...p, disabled: !this.selectedProjectId }));
		},
	},
	methods: {
		findPlacement(placementId) {
			return this.placements.find((placement) => placement.id === placementId);
		},
		selectPlacement({ placementId }) {
			this.selectedPlacement = placementId;
			placementId && this.nextStep();
		},
		getItemName(placement) {
			return PlacementService.getFullItemName(placement);
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@/components/CreationWizard/assets/creation-wizard-vars.scss';
.top-section {
	h3 {
		color: $secondary-content-title-font-color;
		a {
			color: $secondary-content-title-font-color;
		}
	}
}
</style>
